import React from "react";
import { Card, CardActionArea, Box, Typography, Badge } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LocalStorageServices } from "../../../../../../services/localStorageServices";

const PendingItemCard = ({ label, count, status, isBtnShow = false }) => {
  const navigate = useNavigate();
  const baseRouteUrl = `/ecrs_portal/${LocalStorageServices.getUserRole()}/dashboard/list`;

  const handleCardClick = () => {
    if (isBtnShow) {
      navigate(baseRouteUrl, { state: { status } });
    }
  };

  return (
    <Card
      sx={{
        width: "100%",
        minWidth: 240, // ← Forces stable layout
        borderRadius: 2,
        border: "1px solid #e0e0e0",
        backgroundColor: "#f7f9fc",
        height: "100%", // all cards same height
      }}
    >
      <CardActionArea
        onClick={handleCardClick}
        disabled={!isBtnShow}
        sx={{
          p: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: 2,
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              color: "#074D4D",
              fontSize: "1.05rem",
              fontFamily: '"Jost", sans-serif',
            }}
          >
            {label}
          </Typography>

          <Badge
            badgeContent={count}
            showZero
            max={9999}
            sx={{
              mx:1, // ← moves badge slightly left
              "& .MuiBadge-badge": {
                backgroundColor: "#e53935",
                color: "#fff",
                fontSize: "0.8rem",
                fontWeight: 700,
                height: "36px",
                minWidth: "36px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(229,57,53,0.4)",
              },
            }}
          />
        </Box>
      </CardActionArea>
    </Card>
  );
};

export default PendingItemCard;
